import * as React from 'react';
import { SVGProps } from 'react';

const IconMapStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m5 8.113 2 .666V3.887l-2-.666v4.892ZM4 3.277v4.846l-1 .4V3.677l1-.4ZM4.5 2l3 1L10 2v7l-2.5 1-3-1L2 10V3l2.5-1ZM8 8.723l1-.4V3.477l-1 .4v4.846Z"
    />
  </svg>
);
export default IconMapStrokedSizeXs;
